import { Vector4 } from '@zephyr3d/base';

/** @internal */ class ShadowImpl {
    _resourceDirty;
    constructor(){
        this._resourceDirty = true;
    }
    invalidateResource() {
        this._resourceDirty = true;
    }
    updateResources(shadowMapParams) {
        this.doUpdateResources(shadowMapParams);
    }
    getShadowMapClearColor(shadowMapParams) {
        const colorAttachment = shadowMapParams.shadowMapFramebuffer?.getColorAttachments()[0];
        return colorAttachment ? colorAttachment.isFloatFormat() ? new Vector4(1, 1, 1, 1) : new Vector4(0, 0, 0, 1) : null;
    }
}

export { ShadowImpl };
//# sourceMappingURL=shadow_impl.js.map
